import React, { useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { useSelector, useDispatch } from "react-redux";
import FlatView from "./FlatView";
import CascadeView from "./CascadeView";
import SubregionSelection from "./SubregionSelection";
import SingleSelector from "./SingleSelector";
import PromptClickView from "./PromptClickView";
import PanButton from "./PanButton";
import { viewStyles, genomeOptions } from "../constants";
import { initializeRecord } from "../helpers/helpers";
import { dataFileManager } from "../dataFileManager";

const SubregionSelectionWrapper = (props) => {

    const pointerSelection = useSelector(state => state.pointer.selection);
    const calculatedPositions = useSelector(state => state.calculatedPositions[props.genome]);

    let genomes = Object.keys(genomeOptions);
    const [zoom, setZoom] = useState(initializeRecord(genomes, 1000));
    const [pan, setPan] = useState(initializeRecord(genomes, 0));
    const [viewStyle, setViewStyle] = useState(initializeRecord(genomes, "flat"));
    
    const onChange = (event, genome) => {
        props.handleZoomChange(event, genome);
    }

    const handleZoomChange = (val, genome) => {
        zoom[genome] = val;
        setZoom({...zoom});
    
        setPan({LENS_CULINARIS: 0, LENS_TOMENTOSUS: 0});
      };

    const handleLeftPan = (panVal, genome) => {
        let temp = pan[genome] - panVal;
        pan[genome] = temp;
        setPan({...pan});
    };

    const submitViewStyle = (event, genome) => {
        viewStyle[genome] = event.value;
        setViewStyle({...viewStyle});
      };    

    const handleRightPan = (panVal, genome) => {
        let temp = pan[genome] + panVal;
        pan[genome] = temp;
        setPan({...pan});
    };

    return (
        pointerSelection[props.genome].length === 0
        ? <PromptClickView trackName={dataFileManager[props.genome].shortName} />
        :
        <div>
            <div className="dashboard-container dashboard-element">
                <SingleSelector
                    label="View style"
                    current={viewStyle[props.genome]}
                    options={viewStyles}
                    handleChange={submitViewStyle}
                    genome={props.genome}
                />
                <div className="dashboard-container dashboard-related">
                    <p>Zoom</p>
                    <Slider
                        min={500}
                        max={10000}
                        step={500}
                        value={zoom[props.genome]}
                        //onChange={props.handleZoomChange}
                        onChange={e => handleZoomChange(e, props.genome)}
                    />
                </div>
                <div className="dashboard-container dashboard-related">
                    <p>Move</p>
                    <PanButton
                        direction="Left"
                        handlePan={handleLeftPan}
                        label={<>&#x021A4;</>}
                        calculatedPositions={calculatedPositions}
                        genome={props.genome}
                    />
                    <PanButton
                        direction="Right"
                        handlePan={handleRightPan}
                        label={<>&#x021A6;</>}
                        calculatedPositions={calculatedPositions}
                        genome={props.genome}
                    />
                </div>
            </div>
            <SubregionSelection
                key={props.genome}
                genome={props.genome}
                clade={props.clade}
                clickedGenes={pointerSelection[props.genome]}
                //submitCalculatedPositions={props.submitCalculatedPositions}
                zoom={zoom[props.genome]}
                pan={pan[props.genome]}
                viewStyle={viewStyle[props.genome]}
                completeFilter={props.completeFilter}
            />
        </div>
    );
};

export default SubregionSelectionWrapper;
